import React from 'react';
import PropTypes from 'prop-types';
import RoxyOrb from './RoxyOrb';
import { ROXY_STATES, roxyStateWord } from './roxyStates';
import './RoxyLauncher.scss';

/**
 * 56px, Dark Green, with one clipped corner pointing back at the content she
 * is commenting on — never a circle and never a chat icon. The orange dot
 * means unread; it clears on open and only returns when she has something new.
 */
const RoxyLauncher = ({ onClick, state, unread, hidden }) => (
    <button
        type="button"
        className={`roxy-launcher${hidden ? ' roxy-launcher--hidden' : ''}`}
        onClick={onClick}
        aria-label={`Open Roxy — ${roxyStateWord(state)}${unread ? ', 1 unread' : ''}`}
        aria-haspopup="dialog"
    >
        <RoxyOrb state={state} size={44} />
        {unread && <span className="roxy-launcher__unread" aria-hidden="true" />}
    </button>
);

RoxyLauncher.propTypes = {
    onClick: PropTypes.func.isRequired,
    state: PropTypes.oneOf(Object.values(ROXY_STATES)),
    unread: PropTypes.bool,
    hidden: PropTypes.bool,
};

RoxyLauncher.defaultProps = {
    state: ROXY_STATES.IDLE,
    unread: false,
    hidden: false,
};

export default RoxyLauncher;
